import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-01595047"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "recommend-warp"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "height": "100%"
  }
};
const _hoisted_3 = {
  key: 1,
  class: "cms-card-block nodata-warp"
};
const _hoisted_4 = {
  key: 2,
  class: "data-warp"
};
const _hoisted_5 = {
  class: "cms-card-block tab-warp"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_7 = {
  class: "btn-options"
};
const _hoisted_8 = {
  class: "cms-card-block table-warp"
};
const _hoisted_9 = {
  key: 0,
  class: "theme-warp"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1,
  class: "buttons__list",
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "gap": "0 10px"
  }
};
const _hoisted_12 = {
  class: "mg-b--5"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "dynamic_table"
};
const _hoisted_15 = {
  class: "tips"
};
import { nextTick, onMounted, provide, ref } from 'vue';
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import NoData from '@/components/NoData/index.vue';
import TagType from './components/TagType/index.vue';
import ElTabs from './components/ElTabs/index.vue';
import OperationalTheme from './components/OperationalTheme/index.vue';
import ThemeSetting from './ThemeSetting/index.vue';
import OperationPlan from './OperationPlan/index.vue';
import RecommendOperationPreview from './RecommendOperationPreview/index.vue';
import UploadImage from './components/UploadImage/index.vue';
import { useCommon } from '@/store/useCommon';
import { useRoute, useRouter } from 'vue-router';
import { OperatingStatusNew } from '@/assets/config/dicts';
import { clearData, debounce, getItemByProp, getUrlParams } from '@/utils/tools';
import { formValidator, messageBox, validatorNonNull } from '@/utils/validate';
import { usePageConfig } from '@/utils/useComponentConfig';
import { elMessage } from '@/utils';
import { useI18n } from 'vue-i18n';
import { copyVodplusThemeSubitemApi, deleteVodplusThemeSubitemApi, editVodplusThemeSubitemApi, getVodCategoryApi, uploadVodplusCategoryPictureApi, getVodPlusListApi, getOperationPlanThemeApi, getOperationPlanThemeAllItemApi, getOperationPlanListApi, addVodPlusApi, editVodPlusApi, deleteVodPlusApi, addVodplusThemeSubitemApi } from '@/api/vodNew';
import { getcountryListApi, getSysDictListApi } from '@/api/live';
import { themeTypeOptions } from '@/assets/config/dicts';
import { getDynamicOperationPlanApi, getDynamicPlanThemeApi, addDynamicPlanThemeApi, editDynamicPlanThemeApi, uploadDynamicItemImgApi, deleteDynamicPlanThemeApi, getDynamicPlanItemListApi, addDynamicPlanThemeSubitemApi, copyDynamicPlanThemeSubitemApi, updateDynamicPlanConfiApi, editDynamicPlanThemeSubitemApi, deleteDynamicPlanThemeSubitemApi } from '@/api/topic';
import { ElMessage } from 'element-plus';
import DynamicTable from './dynamicTable/index.vue';
import AssociateDialog from './components/AssociateDialog/index.vue';
import TableFirstPage from './TableFirstPage/index.vue';
import { getOperatorNameListApi } from '@/api/authority';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    pageParams: {
      type: Object,
      default: {
        agentId: '',
        uiStyle: 0
      }
    },
    returnBackFn: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const operatorOptions = ref([]);
    const regionFilter = ref(t('全部'));
    const dynamicRegionOptions = ref([{
      id: 0,
      name: 'Global'
    }]); // 运营区域 动态模板 表单中使用

    const dynamicRegionOptionsForForm = ref([{
      id: 0,
      name: 'Global'
    }]);
    const staticRegionOptions = ref([{
      id: '',
      name: 'Global'
    }]);
    const classifyOptions = ref([]);
    const contentTypeOptions = ref([]);
    const dynamicModeType = ref();
    const storeCommon = useCommon();
    const route = useRoute();
    const router = useRouter();
    const tableRef = ref();
    const aoeFormRef = ref(null);
    const themeSetting = reactive({
      visible: false
    });
    const associateObj = ref({
      visible: false,
      data: null,
      showMultiProps: false,
      subAgentId: undefined
    });
    const operationPlan = reactive({
      visible: false
    });
    const recommendOperationPreview = reactive({
      visible: false
    });
    const recommendTypeOperations = ref([{
      label: t('影片推荐'),
      value: 'video'
    }, {
      label: t('分类推荐'),
      value: 'new_category'
    }]);
    const emptyLoading = ref(false);
    const showUploadImage = ref(false);

    const getOperatorList = async () => {
      const {
        code,
        data
      } = await getOperatorNameListApi();

      if (code == '0') {
        // 仅保留 name === 'Flex' 的 children，其余丢弃
        const rawList = Array.isArray(data) ? data : [];
        const flexItem = rawList.find(op => op && op.name === 'Flex');
        dynamicRegionOptions.value = Array.isArray(flexItem?.children) ? [{
          id: '',
          name: t('全部')
        }, ...flexItem.children] : [];
        dynamicRegionOptionsForForm.value = Array.isArray(flexItem?.children) ? [{
          id: 0,
          name: 'Global'
        }, ...flexItem.children] : [];
      }
    };

    provide('pageParams', props.pageParams); // 当前点击推荐位对象信息

    const tableRowData = ref({
      themeTemplateId: null,
      operationPlanThemeId: null,
      themeSubitemId: null,
      size: null,
      displayMode: '',
      programId: 0,
      byTopicFeature: false,
      isAllFeature: false // 名称为All的推荐位

    });
    provide('tableRowData', tableRowData);
    const STATUS_FIELD = {
      waiting: {
        value: t('待执行'),
        color: '#F2994A'
      },
      running: {
        value: t('执行中'),
        color: '#29B87D'
      },
      end: {
        value: t('已结束'),
        color: '#B4B4B4'
      },
      disable: {
        value: t('状态不对，要后端改后续删掉'),
        color: '#B4B4B4'
      },
      enable: {
        value: t('状态不对，要后端改后续删掉'),
        color: '#B4B4B4'
      }
    };
    provide('STATUS_FIELD', STATUS_FIELD); // headerConfig

    const headerConfig = ref({
      title: '推荐管理',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn(); // closeSelectedTag(route)
        }
      }]
    }); // 新增编辑model

    const actionForm = reactive({
      visible: false,
      action: 'add',
      formList: [[{
        label: '推荐方案名称',
        prop: 'name',
        widgetType: 'input',
        required: true,
        maxlength: 100,
        showWordLimit: true
      }], [{
        label: '主题方式',
        prop: 'type',
        widgetType: 'Select',
        required: true,
        list: themeTypeOptions,
        change: val => {
          actionForm.formData.operationPlanId = '';
          actionForm.formData.supportChildMode = val === 'dynamic' ? 0 : undefined;
          getDynamicOperations(val);
        }
      }], [{
        label: '运营方案',
        prop: 'operationPlanId',
        widgetType: 'Select',
        valueKey: 'id',
        labelKey: 'name',
        list: [],
        filterable: true,
        required: true,
        disabled: false
      }], [// {
      //     label: '运营区域', prop: 'region',  widgetType: 'Select', multiple: false,
      //     'collapse-tags-tooltip': true, list: staticRegionOptions, filterable: true, required: true,
      //     valueKey: 'label',
      //     func: (val) => {
      //         aoeFormRef.value.mForm.validateField('region')
      //     },
      //     controller: () => {
      //         // 静态主题
      //         return actionForm.formData.type == 'static'
      //     }
      // },
      {
        label: '运营区域',
        prop: 'region',
        widgetType: 'Select',
        multiple: false,
        valueKey: 'name',
        labelKey: 'name',
        'collapse-tags-tooltip': true,
        list: dynamicRegionOptionsForForm,
        filterable: true,
        required: true,
        func: val => {
          aoeFormRef.value.mForm.validateField('region');
        } // controller: () => {
        //     // 动态主题
        //     return actionForm.formData.type == 'dynamic'
        // }

      }], [{
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        translation: true,
        list: OperatingStatusNew,
        required: true
      }], [{
        label: '支持儿童模式',
        prop: 'supportChildMode',
        widgetType: 'Select',
        list: [{
          label: t('是'),
          value: 1
        }, {
          label: t('否'),
          value: 0
        }],
        required: true,
        controller: () => {
          return actionForm.formData.type == 'dynamic';
        }
      }]],
      formData: {
        name: '',
        operationPlanId: '',
        region: '',
        status: 'enable',
        type: 'static',
        supportChildMode: undefined
      },
      areaFormList: [[{
        label: '运营区域',
        prop: 'region',
        widgetType: 'Select',
        list: dynamicRegionOptionsForForm,
        valueKey: 'name',
        labelKey: 'name',
        required: false,
        filterable: true,
        func: val => {
          aoeFormRef.value.mForm.validateField('region');
        },
        controller: () => {
          // 动态主题
          return actionForm.action != 'addSubitemFormOtherType' && actionForm.action != 'associateCategoryAll';
        }
      }], [{
        label: '选择分类',
        prop: 'classify',
        widgetType: 'Select',
        list: classifyOptions,
        required: true,
        filterable: true,
        valueKey: 'id',
        labelKey: 'name',
        func: val => {
          aoeFormRef.value.mForm.validateField('classify');
        },
        controller: () => {
          // 判断当前表格点击行数据是否为特殊类型推荐位(All / By Topic) 是 -> 显示
          return tableRowData.value.byTopicFeature;
        }
      }], [{
        label: '选择分类',
        prop: 'contentType',
        widgetType: 'Select',
        list: contentTypeOptions,
        required: true,
        filterable: true,
        func: val => {
          aoeFormRef.value.mForm.validateField('contentType');
        },
        controller: () => {
          // 判断当前表格点击行数据是否为特殊类型推荐位(All) 是 -> 显示
          return tableRowData.value.isAllFeature;
        }
      }]],
      areaFormData: {
        region: '',
        classify: ''
      },
      dialogConfig: {
        title: '新增',
        destroyOnClose: true
      },
      rules: {
        name: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入方案名称'),
          trigger: 'blur'
        }],
        operationPlanId: [{
          required: true,
          message: t('请选择运营方案'),
          trigger: 'change'
        }],
        region: [{
          required: true,
          message: t('请选择运营区域'),
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: t('请选择主题方式'),
          trigger: 'blur'
        }]
      },
      areaFormRules: {
        classify: [{
          required: true,
          message: t('请选择分类'),
          trigger: 'blur'
        }],
        contentType: [{
          required: true,
          message: t('请选择分类'),
          trigger: 'blur'
        }]
      },
      confirm: done => {
        console.log('弹框确定', actionForm.action);

        if (actionForm.action === 'copy') {
          // 复制 
          formValidator(aoeFormRef.value.mForm).then(() => {
            copyVodplusThemeSubitem(done);
          }, () => done());
        } else if (actionForm.action === 'editRegion') {
          // 编辑地区
          formValidator(aoeFormRef.value.mForm).then(() => {
            editVodplusThemeSubitem(done);
          }, () => done());
        } else if (actionForm.action === 'addSubitem') {
          // 添加子推荐位(常规类型)
          formValidator(aoeFormRef.value.mForm).then(() => {
            addVodplusThemeSubitem(done);
          }, () => done());
        } else if (actionForm.action === 'addSubitemFormOtherType') {
          // 添加子推荐位(All By Topic类型)
          formValidator(aoeFormRef.value.mForm).then(() => {
            addSubitemFormOtherType(done);
          }, () => done());
        } else if (actionForm.action === 'associateCategoryAll') {
          // 关联All分类
          formValidator(aoeFormRef.value.mForm).then(() => {
            associateCategoryAll(done);
          }, () => done());
        } else {
          // 修改/编辑运营方案
          formValidator(aoeFormRef.value.mForm).then(() => {
            actionForm.action === 'add' ? addVodPlus(done) : editVodPlus(done);
          }, () => done());
        }
      }
    }); // tags config

    const Tags = ref(null);
    const optionsData = reactive({
      tabActiveName: '',
      loading: false
    }); // 响应子组件 nodata 按钮点击事件

    const handleSchemClick = () => {
      // console.log('add schem')
      resetData('add');
    }; // 返回关闭标签


    const closeSelectedTag = view => {
      storeCommon.delTagsView({ ...view
      });
      router.push('/operating/product-operating');
    };

    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      showPageBar: false,
      config: {
        loading: false
      },
      rowKey: 'serialId'
    });
    const tableOptionsBtn = ref([{
      label: '添加计划',
      func: row => {
        console.log('row', row);
        const {
          serialId,
          id,
          size,
          recommendedType
        } = row;
        tableRowData.value.themeTemplateId = serialId;
        tableRowData.value.themeSubitemId = id;
        tableRowData.value.size = size;
        tableRowData.value.displayMode = recommendedType;
        operationPlan.visible = true;
      },
      controller: row => {
        // 类型是否为All/By Topic 是 -> 不显示
        return row.name !== 'All' && row.recommendedType !== 'new_category';
      }
    }, {
      label: '上传图片',
      func: row => {
        console.log('上传图片', row);

        if (row.operationPlanThemeItemId == 0) {
          return elMessage('warning', '请先编辑子推荐位地区');
        }

        showUploadImage.value = true;
        tableRowData.value.size = row.size;
        uploadImageFormData.id = row.id;
        uploadImageFormData.formData = row.pictureList.map(item => {
          return { ...item,
            imgUrl: item.imageUrl
          };
        }) || [];
      },
      controller: row => {
        // 类型是否为All/By Topic 是 -> 显示
        return row.recommendedType == 'new_category' || row.name == 'All';
      }
    }, {
      label: '编辑',
      func: row => {
        let item = getItemByProp(actionForm.areaFormList, 'region');
        tableRowData.value.displayMode = row.displayMode;
        tableRowData.value.byTopicFeature = row.name.toLowerCase() == 'by_topic';
        tableRowData.value.isAllFeature = row.name.toLowerCase() == 'all'; // 判断是否为父级 是 -> 用父级的ID字段

        if (row.isParent) {
          item.list[0].disabled = false;
          tableRowData.value.themeSubitemId = row.id;
        } else {
          // 编辑子推荐位的地区
          item.list[0].disabled = true;
          tableRowData.value.themeSubitemId = row.id;
          tableRowData.value.parentId = row.parentId;
        }

        actionForm.action = 'editRegion';
        actionForm.dialogConfig.title = '编辑';
        actionForm.areaFormData = { ...row
        };
        actionForm.visible = true;
      },
      controller: row => {
        return !row.isParent;
      }
    }, {
      label: '复制',
      func: row => {
        let item = getItemByProp(actionForm.areaFormList, 'region');

        if (row.isParent) {
          item.list[0].disabled = false;
        } else {
          item.list[0].disabled = true;
        }

        tableRowData.value.themeSubitemId = row.id;
        tableRowData.value.parentId = row.parentId;
        tableRowData.value.displayMode = row.displayMode;
        actionForm.action = 'copy';
        actionForm.dialogConfig.title = '复制';
        actionForm.areaFormData = { ...row
        };
        actionForm.visible = true;
      },
      controller: row => {
        // 判断是否为父级 是 -> 不显示
        return !row.isParent;
      }
    }, {
      label: '删除',
      func: row => {
        // 判断是否为分类表格, 分类表格的删除不做限制
        if (row.status === 'running' && !row.isCategoryTable) return elMessage('error', '该推荐位执行中，不允许删除');
        const {
          id
        } = row;
        messageBox('确定删除所选数据吗?').then(async () => {
          const {
            type
          } = currentVodPlusItem.value;
          const res = type === 'static' ? await deleteVodplusThemeSubitemApi(id) : await deleteDynamicPlanThemeSubitemApi(id);

          if (res.code == '0') {
            elMessage('success', '删除成功');
            getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
          }
        });
      },
      controller: row => {
        // 判断是否为父级且状态不能为执行中 是 -> 不显示
        return !row.isParent && row.status !== 'enable';
      }
    }, {
      label: '添加子推荐位',
      func: async row => {
        console.log('添加子推荐位', row);
        const {
          id,
          recommendedType,
          themeSubitemId
        } = row;
        tableRowData.value.displayMode = recommendedType;
        tableRowData.value.themeTemplateId = id;
        tableRowData.value.themeSubitemId = themeSubitemId;
        tableRowData.value.byTopicFeature = row.name.toLowerCase == 'by_topic';
        tableRowData.value.isAllFeature = row.name.toLowerCase == 'all';
        let item = getItemByProp(actionForm.areaFormList, 'region'); // 禁用第一个global选项

        item.list[0].disabled = true;
        actionForm.areaFormData.region = '';
        actionForm.areaFormData.classify = '';
        actionForm.dialogConfig.title = '新增';
        actionForm.action = 'addSubitem';
        actionForm.visible = true;
      },
      controller: row => {
        // 判断是否为父级 是 -> 显示
        return storeCommon.userData.permissionKey.indexOf('OP_PO_RAS') > -1 && row.isParent && row.recommendedType !== 'new_category' && row.name !== 'All';
      }
    }, {
      label: '关联分类',
      func: async row => {
        const {
          type
        } = currentVodPlusItem.value;

        if (type === 'static') {
          // 打开静态主题弹框
          const {
            id,
            recommendedType,
            themeSubitemId,
            programId,
            categoryId
          } = row;
          tableRowData.value.displayMode = recommendedType;
          tableRowData.value.themeTemplateId = id;
          tableRowData.value.themeSubitemId = themeSubitemId;
          tableRowData.value.programId = categoryId || 0;
          uploadImageFormData.id = row.operationPlanThemeItemId;
          let item = getItemByProp(actionForm.areaFormList, 'region');
          item.list[0].disabled = true;
          actionForm.areaFormData.region = '';
          actionForm.dialogConfig.title = '关联分类';
          await getContentTypeOptions();
          await getClassifyOptions();

          if (row.name.toLowerCase() === 'by_topic') {
            tableRowData.value.byTopicFeature = true;
            tableRowData.value.isAllFeature = false;
            actionForm.action = 'addSubitemFormOtherType';
            actionForm.areaFormData.classify = categoryId == 0 ? '' : categoryId;
          } else {
            // ALL分类特殊处理
            tableRowData.value.byTopicFeature = false;
            tableRowData.value.isAllFeature = true;
            actionForm.action = 'associateCategoryAll';
            actionForm.areaFormData.contentType = row.contentType;
          }

          actionForm.visible = true;
        } else {
          //动态主题
          associateObj.value.visible = true;
          associateObj.value.data = row;
          associateObj.value.subAgentId = props.pageParams.agentId;
          associateObj.value.showMultiProps = row.templateCode === 'stb_left_side_property';
        }
      },
      controller: row => {
        // 判断是否为父级 是 -> 显示
        let name = (row.name || '').toLowerCase();
        return row.isParent && (name == 'all' || name == 'by_topic') && row.recommendedType == 'new_category';
      }
    }]);
    const columnConfig = reactive({
      columnList: [{
        label: '序号',
        prop: 'serial',
        width: 100
      }, {
        label: '推荐位名称',
        prop: 'name',
        minWidth: 260
      }, {
        label: '推荐位内容名称',
        minWidth: 260,
        prop: 'content' // formatter: (value: any) => {
        // }

      }, {
        label: '状态',
        prop: 'status',
        // cellSlot: true,
        width: 150,
        formatter: value => {
          if (value != undefined && value != null) {
            return `<span style="color: ${STATUS_FIELD[value].color}">${STATUS_FIELD[value].value}</span>`;
          }
        }
      }, {
        label: '运营区域',
        prop: 'region',
        width: 170,
        formatter: val => val == 'All' || !val ? t('不限') : val
      }, {
        label: '推荐方式',
        prop: 'recommendedType',
        width: 170,
        cellSlot: true,
        formatter: value => {
          if (value == 'topic') {
            return t('manual-by-topic');
          }

          return value && t(value);
        }
      }, {
        label: '显示周期',
        prop: 'period',
        width: 230,
        formatter: value => {
          return value == '0000-00-00 00:00:00-0000-00-00 00:00:00' ? t('不限') : value;
        }
      }, {
        label: '操作',
        prop: 'options',
        cellSlot: true,
        showOverflowTooltip: false,
        fixed: 'right' // widgetType: 'buttons',

      }]
    }); // 获取contentType选项

    const getContentTypeOptions = async () => {
      try {
        const {
          code,
          data
        } = await getSysDictListApi('vod_pro_type');

        if (code == 0) {
          contentTypeOptions.value = data || [];
        }
      } catch (error) {}
    }; // 获取classify选项


    const getClassifyOptions = async () => {
      try {
        let subAgentId = props.pageParams.agentId;
        const {
          code,
          data
        } = await getVodCategoryApi({
          subAgentId
        });

        if (code == 0) {
          classifyOptions.value = data || [];
        }
      } catch (error) {}
    }; // 响应 TagType组件点击事件


    const onTagClick = debounce((item, index) => {
      // 当前标签已激活
      if (item.id === currentVodPlusItem.value.id && item.type === currentVodPlusItem.value.type) return;
      currentVodPlusItem.value = item; // 默认模式为常规模式

      currentVodPlusItem.value.childMode = 0;
      tableRowData.value.operationPlanThemeId = null;
      optionsData.tabActiveName = '';
      operationPlanThemeList.value = null;
      tabList.value = [];
      getOperationPlanTheme(item.id);
    }, 200); // 响应 ElTabs组件点击事件

    const handleTabClick = val => {
      if (optionsData.tabActiveName === val.props.label) return;
      optionsData.tabActiveName = val.props.label;
      tableRowData.value.operationPlanThemeId = val.props.name; // console.log('operationPlanThemeList', operationPlanThemeList.value)
      // console.log('val.props', val.props)

      let businessThemeList = operationPlanThemeList.value[val.props.label] ? operationPlanThemeList.value[val.props.label].businessThemeList : null;

      if (businessThemeList && businessThemeList.length) {
        // 默认激活当前主题businessThemeList的第一项，请求第一项的推荐位数据
        getOperationPlanThemeAllItem(businessThemeList[0].id);
      } else {
        getOperationPlanThemeAllItem(val.props.name);
      }
    }; // 响应 OperationalTheme组件点击事件


    const handleThemeClick = (item, index) => {
      optionsData.loading = true;
      getOperationPlanThemeAllItem(item.id);
    };

    const countriesList = ref([]); // 获取国家

    const getCountries = async () => {
      // const res = await useCountryList() as any
      const res = await getcountryListApi(); // let item = getItemByProp(actionForm.formList, 'region')
      // let item2 = getItemByProp(actionForm.areaFormList, 'region')

      let newRegionData = res.data; // item.list = newRegionData

      staticRegionOptions.value = [...newRegionData];
      countriesList.value = [...newRegionData];
    };

    getCountries();
    provide('countriesList', countriesList); // 根据地区名称获取对应的地区ID

    const getRegionIdByName = regionName => {
      if (!regionName) return undefined;
      const currentType = currentVodPlusItem.value?.type;
      const editingType = actionForm.formData?.type; // 优先以正在编辑的主题类型作为判断依据：
      // - 如果编辑态为 dynamic，无论当前激活主题为何，都按动态主题处理
      // - 如果编辑态缺省，则回落到当前激活主题的类型

      const isDynamicTheme = editingType === 'dynamic' || !editingType && currentType === 'dynamic';
      const item = (dynamicRegionOptionsForForm.value || []).find(it => it?.name === regionName);

      if (!isDynamicTheme) {
        // 静态主题：regionName 对应国家/区域列表的 label 或 name
        console.log('item807', item);
        return item ? item.id : undefined;
      } else {
        // 动态主题：regionName 与动态下发的区域 name 匹配，返回 id
        console.log('item', item);
        return item ? item.id : undefined;
      }
    }; // 运营主题设置按钮点击事件 (点击显示运营主题设置组件)


    const themeSettingClick = () => {
      themeSetting.visible = true;
    }; // 添加推荐管理按钮点击事件


    const handleAdd = () => {
      // 新增默认启用运营方案选项
      let operationItem = getItemByProp(actionForm.formList, 'operationPlanId');
      operationItem.disabled = false;
      let typeItem = getItemByProp(actionForm.formList, 'type');
      typeItem.disabled = false;
      resetData('add'); // 获取运营方案列表

      getDynamicOperations(actionForm.formData.type);
    }; // 重置表单数据


    const resetData = action => {
      clearData(actionForm.formData); // 取消禁用运营区域和主题方式

      let operationItem = getItemByProp(actionForm.formList, 'operationPlanId');
      operationItem.disabled = false;
      let typeItem = getItemByProp(actionForm.formList, 'type');
      typeItem.disabled = false;
      actionForm.formData.status = 'enable';
      actionForm.formData.type = 'static';
      actionForm.formData.region = '';
      actionForm.action = action;
      actionForm.dialogConfig.title = action == 'add' ? '新增' : '编辑';
      actionForm.visible = true;
    }; // 运营方案主题数据列表


    const tabList = ref([]);
    provide('tabList', tabList); // url 地址栏的 agentId

    const agentId = ref(getUrlParams(route).agentId);
    const commandAciton = {
      edit: data => {
        // 编辑默认禁用运营方案选项
        let operationItem = getItemByProp(actionForm.formList, 'operationPlanId');
        operationItem.disabled = true; // 编辑禁用主题方式

        let typeItem = getItemByProp(actionForm.formList, 'type');
        typeItem.disabled = true;
        getDynamicOperations(data.type);
        actionForm.action = 'edit';
        actionForm.dialogConfig.title = '编辑';
        actionForm.formData = { ...data
        };
        actionForm.visible = true;
      },
      delete: data => {
        if (data.status === 'enable') return elMessage('error', '方案运行中，不可删除');
        deleteVodPlus(data.id, data.type);
      }
    }; // VodPlus方案编辑/删除

    const handleCommand = action => {
      commandAciton[action.type](action.data);
    }; // 首个/当前选中VodPlus方案item对象


    const currentVodPlusItem = ref(null);
    provide('currentVodPlusItem', currentVodPlusItem); // 切换常规||儿童模式

    const onModeChange = val => {
      currentVodPlusItem.value.childMode = val;
      getOperationPlanTheme(currentVodPlusItem.value.id);
    }; // 切换运营区域


    const onRegionChange = val => {
      getOperationPlanTheme(currentVodPlusItem.value.id);
    }; // 查询VodPlus方案


    const getVodPlusList = async currentActive => {
      emptyLoading.value = true;

      if (props.pageParams.agentId !== '' && props.pageParams.agentId !== undefined) {
        try {
          const res = await getVodPlusListApi({
            subAgentId: props.pageParams.agentId
          });

          if (res.code == '0') {
            Tags.value = res.data;

            if (res.data.length > 0) {
              if (currentActive !== undefined && res.data[currentActive]) {
                currentVodPlusItem.value = res.data[currentActive];
              } else if (currentActive !== undefined && !res.data[currentActive]) {
                currentVodPlusItem.value = res.data[res.data.length - 1];
              } else if (currentActive == 0) {
                currentVodPlusItem.value = res.data[0];
              }

              currentVodPlusItem.value = currentVodPlusItem.value ? currentVodPlusItem.value : res.data[0];
              console.log('currentVodPlusItem', currentVodPlusItem.value); // 默认模式为常规模式

              currentVodPlusItem.value.childMode = 0;
              getOperationPlanTheme(currentVodPlusItem.value.id || res.data[0].id);
            }
          } else {
            Tags.value = [];
          }
        } catch (error) {
          Tags.value = [];
        }
      } else {
        props.returnBackFn(); // closeSelectedTag(route)
      }

      setTimeout(() => {
        emptyLoading.value = false;
      }, 300);
    }; // 获取运营方案下拉数据列表 type：静态||动态


    const getDynamicOperations = async type => {
      loading.value = true;

      try {
        const {
          code,
          data
        } = type === 'dynamic' ? await getDynamicOperationPlanApi() : await getOperationPlanListApi();
        const planSelectList = getItemByProp(actionForm.formList, 'operationPlanId');

        if (code == 0) {
          planSelectList.list = data ? data : []; // if(type==='dynamic') planSelectList.list  = [{id:1, name: 'nnnnn'}] todo: 关闭一次新增/编辑，然后切换动态主题，运营方案数据不显示，但是接口有返回
        }

        loading.value = false;
      } catch (error) {
        console.log('801error');
        loading.value = false;
      }
    }; // addVodPlus 添加VodPlus方案


    const addVodPlus = async done => {
      try {
        // 动态方案和静态方案可同时运行一个，静态方案由静态接口校验
        // 校验动态方案: 当前Tags中存在动态运行的方案enableItem
        let enableItem = Tags.value.filter(item => item.status === 'enable' && item.type === 'dynamic'); // 新增的方案是动态且运行的方案

        let isEnableAndDynamicPlan = actionForm.formData.type === 'dynamic' && actionForm.formData.status === 'enable';

        if (enableItem.length && isEnableAndDynamicPlan) {
          done();
          return ElMessage({
            type: 'error',
            message: `${t('Recommend already exists for startup')}: ${enableItem[0].name}`
          });
        }

        actionForm.formData.name = actionForm.formData.name.trim();
        let postData = { ...actionForm.formData,
          subAgentId: props.pageParams.agentId,
          id: actionForm.formData.id ? actionForm.formData.id : undefined,
          regionId: getRegionIdByName(actionForm.formData.region)
        };
        const res = actionForm.formData.type == 'static' ? await addVodPlusApi(postData) : await addDynamicPlanThemeApi(postData);

        if (res.code == '0') {
          elMessage('success', '新增成功');
          getVodPlusList();
          actionForm.visible = false;
        }
      } catch (error) {
        console.log('879err', error);
      }

      done();
    }; // editVodPlus 编辑VodPlus方案


    const editVodPlus = async done => {
      try {
        console.log('actionForm.formData=======', actionForm.formData); // 动态方案和静态方案可同时运行一个，静态方案由静态接口校验
        // 这里校验动态方案： 已有Tags中过滤出 运行且动态的主题
        //  现有编辑方案可以校验通过 item.id !== actionForm.formData.id

        let enableItem = Tags.value.filter(item => item.status === 'enable' && item.type === 'dynamic' && item.id !== actionForm.formData.id); // 当前新增的是否动态主题且允许的

        let isEnableAndDynamicPlan = actionForm.formData.type === 'dynamic' && actionForm.formData.status === 'enable';

        if (enableItem.length && isEnableAndDynamicPlan) {
          done();
          return ElMessage({
            type: 'error',
            message: `${t('Recommend already exists for startup')}: ${enableItem[0].name}`
          });
        }

        actionForm.formData.name = actionForm.formData.name.trim();
        let putData = { ...actionForm.formData,
          subAgentId: props.pageParams.agentId,
          childMode: undefined,
          regionId: getRegionIdByName(actionForm.formData.region)
        };
        const res = actionForm.formData.type === 'static' ? await editVodPlusApi(putData) : await editDynamicPlanThemeApi(putData);

        if (res.code == '0') {
          elMessage('success', '编辑成功'); // 若编辑的是当前激活的方案，则传入其 currentActive，下次仍保持该标签激活

          const isEditingActive = currentVodPlusItem.value && actionForm.formData.id === currentVodPlusItem.value.id;

          if (isEditingActive) {
            const currentActive = Tags.value.findIndex(item => item.id === actionForm.formData.id);

            if (currentActive >= 0) {
              getVodPlusList(currentActive);
            } else {
              getVodPlusList();
            }
          } else {
            getVodPlusList();
          }

          actionForm.visible = false;
        }
      } catch (error) {
        console.log('1045-err', error);
      }

      done();
    }; // deleteVodPlus 删除VodPlus方案


    const deleteVodPlus = async (id, type) => {
      messageBox('确定删除所选数据吗?').then(async () => {
        const {
          code
        } = type === 'static' ? await deleteVodPlusApi({
          id
        }) : await deleteDynamicPlanThemeApi(id);

        if (code == '0') {
          elMessage('success', '删除成功'); // 删除项是否当前选中

          if (currentVodPlusItem.value && id == currentVodPlusItem.value.id) {
            currentVodPlusItem.value = null;
            tableRowData.value.operationPlanThemeId = null;
            optionsData.tabActiveName = '';
            operationPlanThemeList.value = null;
            tabList.value = []; // 是
            // 删除项是否为第一项

            const tagsItemIndex = Tags.value.findIndex(item => item.id == id);
            let currentActive = 0;

            if (tagsItemIndex > 0) {
              // 否 (tagsItemIndex > 1)
              currentActive = tagsItemIndex;
            } else {
              // 是 (tagsItemIndex == 0)
              currentActive = 0;
            }

            getVodPlusList(currentActive);
          } else {
            // 否
            getVodPlusList();
          }
        }
      });
    }; // 运营主题显示模块对象信息


    const operationPlanThemeList = ref(null); // 查询VodPlus运营方案主题  

    const getOperationPlanTheme = async operationPlanId => {
      //console.log('currentVodPlusItem', currentVodPlusItem.value)
      try {
        const {
          type
        } = currentVodPlusItem.value;
        const res = type === 'static' ? await getOperationPlanThemeApi({
          vodplusOperatePlanId: operationPlanId
        }) : await getDynamicPlanThemeApi({
          vodplusOperatePlanId: operationPlanId
        });

        if (res.code == '0') {
          tabList.value = res.data.map(item => {
            return { ...item // itemSlot: item.type == 'operational' ? true : false

            };
          });

          if (res.data.length > 0) {
            let obj = {};
            res.data.forEach(item => {
              // 过滤掉停运的主题
              item.businessThemeList = item.businessThemeList ? item.businessThemeList.filter(theme => theme.status !== 'end') : null;
              obj[item.name] = item;
            }); // console.log('obj', obj)
            // operationPlanThemeList 只有状态非停运的主题

            operationPlanThemeList.value = obj;
            tableRowData.value.operationPlanThemeId = tableRowData.value.operationPlanThemeId !== null ? tableRowData.value.operationPlanThemeId : res.data[0].id; // 默认激活的第一个主题名称

            optionsData.tabActiveName = optionsData.tabActiveName ? optionsData.tabActiveName : res.data[0].name; // 对应主题名称下的businessThemeList

            let businessThemeList = operationPlanThemeList.value[optionsData.tabActiveName] ? operationPlanThemeList.value[optionsData.tabActiveName].businessThemeList : null;

            if (businessThemeList && businessThemeList.length) {
              // 默认激活当前主题businessThemeList的第一项，请求第一项的推荐位数据
              getOperationPlanThemeAllItem(businessThemeList[0].id);
            } else {
              getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId || res.data[0].id);
            }
          }
        }
      } catch (error) {}
    }; // 获取列表


    const getOperationPlanThemeAllItem = async operationPlanThemeId => {
      optionsData.loading = true;

      try {
        const {
          type,
          childMode
        } = currentVodPlusItem.value;
        let params = {
          vodplusOperatePlanThemeId: operationPlanThemeId,
          childMode: type === 'static' ? undefined : childMode,
          region: regionFilter.value === t('全部') ? undefined : regionFilter.value
        };
        const res = type === 'static' ? await getOperationPlanThemeAllItemApi(params) : await getDynamicPlanItemListApi(params);

        if (res.code == '0') {
          // console.log('tableConfig.data', tableConfig.data)
          switch (type) {
            case 'static':
              tableConfig.data = setSerial(res.data);
              break;

            case 'dynamic':
              // 处理动态数据
              const processedData = res.data.map(item => {
                return { ...item,
                  themeComponentItemList: setSerial(item.themeComponentItemList) // 处理 themeComponentItemList

                };
              }); // 过滤phone的phone_history类型，不显示

              tableConfig.data = processedData.filter(item => item.templateCode !== 'phone_history');
              console.log('tableConfig.data', tableConfig.data);
              break;

            default:
              tableConfig.data = setSerial(res.data);
              break;
          }

          optionsData.loading = false;
        }
      } catch (error) {
        optionsData.loading = false;
      }
    }; // 响应添加计划页面组件返回按钮点击事件


    const updateData = () => {
      getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
    }; // 处理接口返回列表数据(父级)


    const setSerial = list => {
      if (list != null && list.length > 0) {
        list = list.map((item, index) => {
          item.serial = index + 1;
          item.serialId = index + 1;
          item.isParent = true;
          item.period = item.scheduleStartTime && item.scheduleEndTime ? item.scheduleStartTime + '-' + item.scheduleEndTime : ''; // 静态主题的子推荐位在item.item，动态主题的子推荐位在item.subItemList

          let childrenList = null;

          if (item.item != null && item.item.length > 0) {
            // 静态主题的子推荐位
            childrenList = item.item;
          } else if (item.subItemList != null && item.subItemList.length > 0) {
            // 动态主题的子推荐位
            childrenList = item.subItemList;
          }

          if (childrenList) {
            item = { ...item,
              children: setChildSerial(childrenList, item)
            };
          } // 关联分类名称


          item.categoryName = props.pageParams.categoryName;
          return item;
        });
        return list;
      } else {
        return list;
      }
    }; // 处理接口返回列表数据(子级 带children字段)


    const setChildSerial = (list, parentItem) => {
      if (list != null && list.length > 0) {
        list = list.map((item, index) => {
          item.contentName = item.name;
          item.name = parentItem.name;
          item.serial = index + 1;
          item.serialId = parentItem.serialId + '.' + (index + 1);
          item.displayMode = item.displayMode || parentItem.displayMode;
          item.period = item.scheduleStartTime && item.scheduleEndTime ? item.scheduleStartTime + '-' + item.scheduleEndTime : '';

          if (item.item) {
            item.children = setChildSerial(item.item, item);
          } // 关联分类名称


          item.categoryName = props.pageParams.categoryName;
          return item;
        });
        return list;
      } else {
        return list;
      }
    }; // 复制子推荐位


    const copyVodplusThemeSubitem = async done => {
      try {
        const {
          type
        } = currentVodPlusItem.value;
        const {
          parentId,
          themeSubitemId
        } = tableRowData.value;
        const {
          region
        } = actionForm.areaFormData;
        let dynamicRegionId = dynamicRegionOptions.value.find(item => item.name === actionForm.areaFormData.region)?.id;
        let regionId = type === 'dynamic' ? dynamicRegionId : getRegionIdByName(actionForm.areaFormData.region);
        let params = {
          subItemId: themeSubitemId,
          region: region
        };
        const res = type === 'static' ? await copyVodplusThemeSubitemApi(params) : await copyDynamicPlanThemeSubitemApi({
          parentId,
          id: themeSubitemId,
          region: region,
          regionId: regionId
        });

        if (res.code == '0') {
          elMessage('success', '复制成功'); // tableConfig.data = []

          actionForm.visible = false;
          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
        }
      } catch (error) {}

      done();
    }; // 编辑子推荐位


    const editVodplusThemeSubitem = async done => {
      try {
        const {
          type
        } = currentVodPlusItem.value;
        let dynamicRegionId = dynamicRegionOptions.value.find(item => item.name === actionForm.areaFormData.region)?.id;
        let params = {
          id: tableRowData.value.themeSubitemId,
          region: actionForm.areaFormData.region,
          regionId: type === 'dynamic' ? dynamicRegionId : getRegionIdByName(actionForm.areaFormData.region),
          parentId: type === 'dynamic' ? tableRowData.value.parentId : undefined
        };
        const res = type === 'static' ? await editVodplusThemeSubitemApi(params) : await editDynamicPlanThemeSubitemApi(params);

        if (res.code == '0') {
          elMessage('success', '编辑成功');
          actionForm.visible = false;
          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
        }
      } catch (error) {}

      done();
    }; // 添加子推荐位(常规类型)


    const addVodplusThemeSubitem = async done => {
      try {
        const {
          type
        } = currentVodPlusItem.value;
        let dynamicRegionId = dynamicRegionOptions.value.find(item => item.name === actionForm.areaFormData.region)?.id;
        let regionId = type === 'dynamic' ? dynamicRegionId : getRegionIdByName(actionForm.areaFormData.region);
        console.log('regionId', regionId);
        let putData = {
          id: tableRowData.value.themeTemplateId,
          region: actionForm.areaFormData.region,
          regionId: regionId
        };
        const res = type === 'static' ? await addVodplusThemeSubitemApi(putData) : await addDynamicPlanThemeSubitemApi({
          parentId: tableRowData.value.themeTemplateId,
          region: actionForm.areaFormData.region,
          regionId: regionId
        });

        if (res.code == '0') {
          elMessage('success', '操作成功'); // tableConfig.data = []

          actionForm.visible = false;
          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
        }
      } catch (error) {}

      done();
    }; // 添加子推荐位(类型 by topic/All)


    const addSubitemFormOtherType = async done => {
      console.log(990);

      try {
        let params = {
          id: tableRowData.value.themeTemplateId,
          categoryId: actionForm.areaFormData.classify
        };
        let isByTopicOrAll = tableRowData.value.byTopicFeature || tableRowData.value.isAllFeature; // By_Topic || All 用editVodplusThemeSubitemApi， 其他的视为新增，用addVodplusThemeSubitemApi

        const res = isByTopicOrAll ? await editVodplusThemeSubitemApi(params) : await addVodplusThemeSubitemApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功'); // tableConfig.data = []

          actionForm.visible = false;
          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
        }
      } catch (error) {}

      done();
    }; // 关联All分类


    const associateCategoryAll = async done => {
      try {
        let params = {
          id: tableRowData.value.themeTemplateId,
          contentType: actionForm.areaFormData.contentType
        };
        const res = await editVodplusThemeSubitemApi(params);

        if (res.code == 0) {
          elMessage('success', '操作成功');
          actionForm.visible = false;
          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
        }
      } catch (error) {} finally {
        done();
      }
    }; // 推荐位(类型 by topic/All) 上传图片需要的参数


    const uploadImageFormData = reactive({
      id: '',
      formData: []
    }); // 上传图片组件确认按钮点击事件

    const onUploadImageComfirm = async (params, done) => {
      try {
        const {
          type
        } = currentVodPlusItem.value;
        let pictureList = JSON.parse(JSON.stringify(params));
        pictureList.forEach(item => {
          delete item.file;

          if (item.type == 0) {
            delete item.base64Image;
            delete item.type;
            delete item.imgUrl;
          } else {
            item.base64Image = item.base64Image.split('base64,')[1];
            delete item.url;
            delete item.type;
            delete item.imgUrl;
          }

          item.vodplusThemeItemId = uploadImageFormData.id;
        }); // 推荐位(类型 by topic/All) 上传图片调用接口

        const res = type === 'static' ? await uploadVodplusCategoryPictureApi(pictureList) : await uploadDynamicItemImgApi(pictureList);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
          done();
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    }; // 推荐方式改变


    const onRecommendedTypeChange = async (row, val) => {
      optionsData.loading = true;

      try {
        let params = {
          id: row.id,
          recommendedType: val
        };
        const res = await editVodplusThemeSubitemApi(params);

        if (res.code == '0') {
          elMessage('success', '编辑成功');
          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
        }
      } catch (error) {
        console.log('1058-error', error);
        getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
      }

      optionsData.loading = false;
    };

    const recommenSortOptions = ref([]); // 获取推荐顺序选项

    const getRecommendOptions = async () => {
      const {
        code,
        data
      } = await getSysDictListApi('recommended_sort ');

      if (code == 0) {
        recommenSortOptions.value = data ? data.map(item => {
          return { ...item,
            label: t(item.label)
          };
        }) : [];
      }
    };

    const categoryOptions = ref([]); // 获取分类

    const getCategoryOptions = async () => {
      try {
        const {
          code,
          data
        } = await getVodCategoryApi({
          subAgentId: props.pageParams.agentId
        });

        if (code == 0) {
          categoryOptions.value = data ? data : [];
        }
      } catch (error) {}
    }; // 点了首次进来页面的ok按钮


    const handleOk = async row => {
      console.log('okkkkkk', row);

      try {
        let postData = {
          configured: 1,
          titleOn: row.titleOn,
          type: row.type,
          imageType: row.imageType,
          itemCount: row.itemCount,
          categoryCount: row.templateCode === 'stb_d_h_r6r6_category' ? 12 : row.categoryCount,
          vodplusDynamicThemeComponentId: row.id
        };
        const {
          code,
          data
        } = await updateDynamicPlanConfiApi(postData);

        if (code == 0) {
          elMessage('success', t('操作成功')); // 获取下方表单数据

          getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId);
        }
      } catch (error) {}
    };

    onMounted(() => {
      getOperatorList();
      getCategoryOptions();
      getRecommendOptions();
      getDynamicOperations('static');
      getVodPlusList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      const _directive_permission = _resolveDirective("permission");

      return _openBlock(), _createElementBlock(_Fragment, null, [!themeSetting.visible && !operationPlan.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), emptyLoading.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [[_directive_loading, emptyLoading.value]]) : _createCommentVNode("", true), !emptyLoading.value && Tags.value && Tags.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(NoData, {
        onSchemeClick: handleSchemClick
      })])) : _createCommentVNode("", true), !emptyLoading.value && Tags.value && Tags.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => Tags.value = $event),
        onOnTagClick: _unref(onTagClick),
        onOnAddClick: handleAdd,
        onHandleCommand: handleCommand,
        "current-active": currentVodPlusItem.value.id + currentVodPlusItem.value.type || -1
      }, null, 8, ["modelValue", "onOnTagClick", "current-active"]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_5, [_createVNode(ElTabs, {
        "tab-active-name": tableRowData.value.operationPlanThemeId,
        "tab-lists": tabList.value,
        onOnTabClick: handleTabClick
      }, {
        itemSlot: _withCtx(scope => [_createElementVNode("div", _hoisted_6, [scope.businessThemeList.length && scope.businessThemeList[0] ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          style: _normalizeStyle([{
            "display": "inline-block",
            "width": "10px",
            "height": "10px",
            "border-radius": "50%",
            "position": "absolute",
            "left": "3px"
          }, `background-color:${STATUS_FIELD[scope.businessThemeList[0].status].color}`])
        }, null, 4)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(scope.name), 1)])]),
        _: 1
      }, 8, ["tab-active-name", "tab-lists"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_select, {
        modelValue: regionFilter.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => regionFilter.value = $event),
        style: {
          "width": "120px",
          "margin-right": "10px"
        },
        onChange: onRegionChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...dynamicRegionOptions.value], item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.name,
            value: item.name
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), currentVodPlusItem.value.type === 'dynamic' ? (_openBlock(), _createBlock(_component_el_select, {
        key: 0,
        modelValue: currentVodPlusItem.value.childMode,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => currentVodPlusItem.value.childMode = $event),
        style: {
          "width": "140px",
          "margin-right": "10px"
        },
        onChange: onModeChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          key: "value",
          label: _ctx.$t('常规模式'),
          value: 0
        }, null, 8, ["label"]), currentVodPlusItem.value.supportChildMode === 1 ? (_openBlock(), _createBlock(_component_el_option, {
          key: "value",
          label: _ctx.$t('儿童模式'),
          value: 1
        }, null, 8, ["label"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), currentVodPlusItem.value.type === 'static' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        onClick: _cache[3] || (_cache[3] = $event => recommendOperationPreview.visible = true),
        class: "cms-op-btn cms-op-btn-main"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('预览')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: themeSettingClick,
        class: "cms-op-btn cms-op-btn-main"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('运营主题设置')), 1)]),
        _: 1
      })), [[_directive_permission, 'OP_PO_RTS']]), currentVodPlusItem.value.type === 'static' ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
        key: 2,
        "column-list": columnConfig.columnList.filter(f => f.label != '操作'),
        onFilterColumnItemChange: filterColumnItemChange
      }, null, 8, ["column-list"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_8, [operationPlanThemeList.value && operationPlanThemeList.value[optionsData.tabActiveName] && operationPlanThemeList.value[optionsData.tabActiveName].businessThemeList && operationPlanThemeList.value[optionsData.tabActiveName].businessThemeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(OperationalTheme, {
        "theme-lists": operationPlanThemeList.value[optionsData.tabActiveName].businessThemeList,
        onOnThemeClick: handleThemeClick,
        labelName: "operationThemeName"
      }, null, 8, ["theme-lists"])])) : _createCommentVNode("", true), !currentVodPlusItem.value || currentVodPlusItem.value.type === 'static' ? (_openBlock(), _createBlock(_component_common_table, {
        key: 1,
        ref_key: "tableRef",
        ref: tableRef,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.config
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(({
            row,
            column
          }) => [column.property == 'recommendedType' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_select, {
            modelValue: row.recommendedType,
            "onUpdate:modelValue": $event => row.recommendedType = $event,
            onChange: value => onRecommendedTypeChange(row, value)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendTypeOperations.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])])) : _createCommentVNode("", true), column.property == 'options' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableOptionsBtn.value, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.label == '上传图片' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [row.pictureList && item.controller(row) ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              width: 220,
              trigger: "hover",
              placement: "top"
            }, {
              reference: _withCtx(() => [_createElementVNode("span", null, [item.controller(row) ? (_openBlock(), _createBlock(_component_el_button, _mergeProps({
                key: 0,
                style: {
                  "margin-left": "0"
                }
              }, item, {
                type: item.type || 'primary',
                link: "",
                onClick: $event => item.func(row)
              }), {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
                _: 2
              }, 1040, ["type", "onClick"])) : _createCommentVNode("", true)])]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.pictureList || [], (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index
                }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.posterType == 'common' ? _ctx.$t('通用') : item.posterType == 'android' ? _ctx.$t('安卓') : _ctx.$t('手机')), 1), _createElementVNode("img", {
                  style: {
                    "width": "100%",
                    "height": "100%"
                  },
                  src: item.imageUrl,
                  alt: ""
                }, null, 8, _hoisted_13)])]);
              }), 128))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), !row.pictureList && item.controller(row) ? (_openBlock(), _createBlock(_component_el_button, _mergeProps({
              key: 1,
              style: {
                "margin-left": "0"
              }
            }, item, {
              type: item.type || 'primary',
              link: "",
              onClick: $event => item.func(row)
            }), {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
              _: 2
            }, 1040, ["type", "onClick"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), item.label !== '上传图片' && item.controller(row) ? (_openBlock(), _createBlock(_component_el_button, _mergeProps({
              key: 1,
              style: {
                "margin-left": "0"
              }
            }, item, {
              type: item.type || 'primary',
              link: "",
              onClick: $event => item.func(row)
            }), {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
              _: 2
            }, 1040, ["type", "onClick"])) : _createCommentVNode("", true)], 64);
          }), 128))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "options"])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 2
      }, _renderList(tableConfig.data, item => {
        return _openBlock(), _createElementBlock("div", _hoisted_14, [item.configured == 0 ? (_openBlock(), _createBlock(TableFirstPage, {
          key: 0,
          onConfigOk: handleOk,
          rowData: item
        }, null, 8, ["rowData"])) : (_openBlock(), _createBlock(DynamicTable, {
          key: 1,
          dynamicData: item,
          sortOperations: recommenSortOptions.value,
          onAddPlan: tableOptionsBtn.value[0].func,
          onUploadImg: tableOptionsBtn.value[1].func,
          onOnEdit: tableOptionsBtn.value[2].func,
          onOnCopy: tableOptionsBtn.value[3].func,
          onOnDelete: tableOptionsBtn.value[4].func,
          onOnAddSubCategory: tableOptionsBtn.value[5].func,
          onOnAssociate: tableOptionsBtn.value[6].func,
          onOnUpdateList: _cache[4] || (_cache[4] = $event => getOperationPlanThemeAllItem(tableRowData.value.operationPlanThemeId)),
          categoryOptions: categoryOptions.value,
          onConfigOk: handleOk
        }, null, 8, ["dynamicData", "sortOperations", "onAddPlan", "onUploadImg", "onOnEdit", "onOnCopy", "onOnDelete", "onOnAddSubCategory", "onOnAssociate", "categoryOptions"]))]);
      }), 256))])])), [[_directive_loading, optionsData.loading]])])) : _createCommentVNode("", true), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [actionForm.action === 'add' || actionForm.action === 'edit' ? _withDirectives((_openBlock(), _createBlock(_component_FormTable, {
          key: 0,
          ref_key: "aoeFormRef",
          ref: aoeFormRef,
          "form-list": actionForm.formList,
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, null, 8, ["form-list", "form-data", "rules"])), [[_directive_loading, loading.value]]) : (_openBlock(), _createBlock(_component_FormTable, {
          key: 1,
          ref_key: "aoeFormRef",
          ref: aoeFormRef,
          "form-list": actionForm.areaFormList,
          "form-data": actionForm.areaFormData,
          rules: actionForm.areaFormRules
        }, null, 8, ["form-list", "form-data", "rules"]))]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"])])) : _createCommentVNode("", true), _createVNode(ThemeSetting, {
        modelValue: themeSetting.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => themeSetting.visible = $event),
        onUploadPlanTheme: _cache[7] || (_cache[7] = $event => getOperationPlanTheme(currentVodPlusItem.value.id))
      }, null, 8, ["modelValue"]), _createVNode(OperationPlan, {
        modelValue: operationPlan.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => operationPlan.visible = $event),
        onUpdateData: updateData
      }, null, 8, ["modelValue"]), _createVNode(RecommendOperationPreview, {
        modelValue: recommendOperationPreview.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => recommendOperationPreview.visible = $event)
      }, null, 8, ["modelValue"]), _createVNode(UploadImage, {
        modelValue: showUploadImage.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showUploadImage.value = $event),
        "form-data": uploadImageFormData.formData,
        onOnComfirm: onUploadImageComfirm
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('推荐位尺寸图片上传提示', {
          size: tableRowData.value.size
        })), 1)]),
        _: 1
      }, 8, ["modelValue", "form-data"]), _createVNode(AssociateDialog, {
        modelValue: associateObj.value.visible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => associateObj.value.visible = $event),
        data: associateObj.value.data,
        subAgentId: associateObj.value.subAgentId,
        showMultiProps: associateObj.value.showMultiProps,
        onUpdateList: updateData
      }, null, 8, ["modelValue", "data", "subAgentId", "showMultiProps"])], 64);
    };
  }

});